import styled, { css } from 'styled-components';
import { Heading, ApplyButton } from 'components';
import { media, color } from 'style';

export default {
  Container: styled.div`
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  `,
  Title: styled(Heading)`
    text-align: center;
  `,
  SubTitle: styled(Heading)`
    width: 100%;
    max-width: 670px;
    margin-top: 10px;
    text-align: center;
  `,
  StepContainer: styled.div`
    display: flex;
    flex-flow: column nowrap;
    align-items: start;
    margin-top: 50px;

    ${media.md`
      width: 100%;
      max-width: 900px;
      flex-flow: row nowrap;
    `}
  `,
  Description: styled.div`
    width: 100%;
    /* max-width: 800px; */
    text-align: center;
  `,
  FAQ: styled.div`
    margin-top: 40px;
  `,
  ApplyButton: styled(ApplyButton)`
    margin-top: 40px;
  `,
  Step: styled.div`
    display: flex;
    flex-flow: row nowrap;

    ${media.md`
      flex: 1;
      flex-flow: column nowrap;
      align-items: start;
    `}
  `,
  StepLine: styled.div`
    display: flex;
    flex-flow: column nowrap;
    align-items: center;

    ${media.md`
      width: 100%;
      flex-flow: row nowrap;
    `}
  `,
  Circle: styled.div`
    flex-basis: 12px;
    width: 12px;
    border-radius: 50%;
    border: 6px solid ${color.hmBrandPurple};

    ${media.md`
      height: 12px;
    `}
  `,
  Line: styled.div<{ isArrow?: boolean; isDot?: boolean }>`
    position: relative;
    flex: 1;
    background-color: ${color.hmPurple4};
    height: 0px;
    border: 3px solid ${color.hmPurple4};

    ${({ isArrow }) =>
      isArrow &&
      css`
        :after {
          display: inline-block;
          position: absolute;
          top: calc(100% - 15px);
          left: -10px;
          content: '';
          width: 15px;
          height: 15px;
          border-top: 5px solid ${color.hmPurple4};
          border-right: 5px solid ${color.hmPurple4};
          transform: rotate(135deg);
        }

        ${media.md`
          :after {
            top: -10px;
            left: calc(100% - 15px);
            transform: rotate(45deg);
          }
      `}
      `}

    ${({ isDot }) =>
      isDot &&
      css`
        :after {
          --radius: 17px;
          position: absolute;
          bottom: -4px;
          content: '';
          width: var(--radius);
          height: var(--radius);
          border-radius: calc(var(--radius) / 2);
          background-color: ${color.hmPurple4};
          transform: translateX(-50%);
          margin: 0;
        }

        ${media.md`
          :after {
            bottom: calc(var(--radius) * -1);
            right: -4px;
            transform: translateY(-50%);
          }`}
      `}
  `,
  Content: styled.div`
    margin-left: 12px;
  `,
  StepTitle: styled(Heading)`
    margin-top: 1px;
    font-weight: 600;

    ${media.md`
      margin-top: 7px;
    `}
  `,
  StepList: styled.ul`
    padding-left: 35px;
    line-height: 25px;
    font-size: 16px;
  `,
  StepListItem: styled.li``,
};
